import { useState } from 'react';
import styles from './styles.module.less';
import Header from './components/Header';
import InProgressTab from './components/InProgressTab';
import CompletedTab from './components/CompletedTab';
import InPipelineTab from './components/InPipelineTab';
import Tabs from './components/Tabs';
import { useTypeSafeTranslation } from 'hooks';

type IFilterType = 'inprogress' | 'in-pipeline' | 'completed';

const UpcomingPage = () => {
  const [filterType, setFilterType] = useState<IFilterType>('inprogress');
  const { t } = useTypeSafeTranslation();
  return (
    <>
      <Header />
      <div className={styles.root}>
        <div className={styles.tabs}>
          <Tabs
            datas={[
              { label: t('upcoming.in_pipeline'), value: 'in-pipeline' },
              { label: t('upcoming.in_progress'), value: 'inprogress' },
              { label: t('upcoming.completed'), value: 'completed' },
            ]}
            value={filterType}
            onChange={(e) => {
              setFilterType(e.target.value);
            }}
          />
        </div>

        {filterType === 'inprogress' && <InProgressTab />}
        {filterType === 'in-pipeline' && <InPipelineTab />}
        {filterType === 'completed' && <CompletedTab />}
      </div>
    </>
  );
};

export default UpcomingPage;

UpcomingPage.theme = 'dark';
